const initialState = {
  paymentData: [],
  receiptData: [],
  currentKey: "",
};

export function BookingBrokerReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_PAYMENT_DETAILS": {
      return {
        ...state,
        paymentData: state.paymentData.some(item => item._id === action.payload._id)
          ? state.paymentData.map(item =>
            item._id === action.payload._id ? action.payload : item
          )
          : [...state.paymentData, action.payload],
      };
    }
    case "SET_ALL_PAYMENT_DETAILS": {
      return {
        ...state,
        paymentData: [...state.paymentData, ...action.payload],
      };
    }
    case "SET_RECEIPT_DETAILS": {
      return {
        ...state,
        receiptData: state.receiptData.some(item => item._id === action.payload._id)
          ? state.receiptData.map(item =>
            item._id === action.payload._id ? action.payload : item
          )
          : [...state.receiptData, action.payload],
      };
    }
    case "SET_ALL_RECEIPT_DETAILS": {
      return {
        ...state,
        receiptData: [...state.receiptData, ...action.payload],
      };
    }
    case "DELETE_BY_ID": {
      return {
        ...state,
        paymentData: state.paymentData.filter(
          (item) => item._id !== action.payload
        ),
        receiptData: state.receiptData.filter(
          (item) => item._id !== action.payload
        ),
      };
    }
    case "SET_CURRENT_KEY": {
      return {
        ...state,
        currentKey: action.payload,
      };
    }
    case "CLEAR_VOUCHER_DETAILS": {
      return {
        ...state,
        paymentData: [],
        receiptData: [],
        currentKey: "",
      };
    }
    default: {
      return state;
    }
  }
}
